import type { $Fetch } from 'ofetch';
import type {
  EducationLevel, UpsertEducationLevelCommand,
  KnowledgeArea, UpsertKnowledgeAreaCommand,
  Titulacao, UpsertTitulacaoCommand,
  RegraRematricula, UpsertRegraRematriculaCommand,
} from '@/domain/model/CatalogConfig';
import type {
  EducationLevelGateway, KnowledgeAreaGateway, TitulacaoGateway, RegraRematriculaGateway,
} from '@/application/port/out/CatalogConfigGateways';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** HTTP gateways das configs do catálogo. Authorities `catalog:{...}:read|manage`. */
export class HttpEducationLevelGateway implements EducationLevelGateway {
  private readonly path = '/api/v1/education-levels';
  constructor(private readonly client: $Fetch) {}
  async list(): Promise<EducationLevel[]> {
    const res = await this.client<ApiResponse<EducationLevel[]>>(this.path, { method: 'GET' });
    assertApiSuccess(res); return res.data;
  }
  async create(cmd: UpsertEducationLevelCommand): Promise<EducationLevel> {
    const res = await this.client<ApiResponse<EducationLevel>>(this.path, { method: 'POST', body: cmd });
    assertApiSuccess(res); return res.data;
  }
  async update(id: string, cmd: UpsertEducationLevelCommand): Promise<EducationLevel> {
    const res = await this.client<ApiResponse<EducationLevel>>(`${this.path}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res); return res.data;
  }
}

export class HttpKnowledgeAreaGateway implements KnowledgeAreaGateway {
  private readonly path = '/api/v1/knowledge-areas';
  constructor(private readonly client: $Fetch) {}
  async list(): Promise<KnowledgeArea[]> {
    const res = await this.client<ApiResponse<KnowledgeArea[]>>(this.path, { method: 'GET' });
    assertApiSuccess(res); return res.data;
  }
  async create(cmd: UpsertKnowledgeAreaCommand): Promise<KnowledgeArea> {
    const res = await this.client<ApiResponse<KnowledgeArea>>(this.path, { method: 'POST', body: cmd });
    assertApiSuccess(res); return res.data;
  }
  async update(id: string, cmd: UpsertKnowledgeAreaCommand): Promise<KnowledgeArea> {
    const res = await this.client<ApiResponse<KnowledgeArea>>(`${this.path}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res); return res.data;
  }
}

export class HttpTitulacaoGateway implements TitulacaoGateway {
  private readonly path = '/api/v1/titulacoes';
  constructor(private readonly client: $Fetch) {}
  async list(): Promise<Titulacao[]> {
    const res = await this.client<ApiResponse<Titulacao[]>>(this.path, { method: 'GET' });
    assertApiSuccess(res); return res.data;
  }
  async create(cmd: UpsertTitulacaoCommand): Promise<Titulacao> {
    const res = await this.client<ApiResponse<Titulacao>>(this.path, { method: 'POST', body: cmd });
    assertApiSuccess(res); return res.data;
  }
  async update(id: string, cmd: UpsertTitulacaoCommand): Promise<Titulacao> {
    const res = await this.client<ApiResponse<Titulacao>>(`${this.path}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res); return res.data;
  }
}

export class HttpRegraRematriculaGateway implements RegraRematriculaGateway {
  private readonly path = '/api/v1/regras-rematricula';
  constructor(private readonly client: $Fetch) {}
  async list(): Promise<RegraRematricula[]> {
    const res = await this.client<ApiResponse<RegraRematricula[]>>(this.path, { method: 'GET' });
    assertApiSuccess(res); return res.data;
  }
  async create(cmd: UpsertRegraRematriculaCommand): Promise<RegraRematricula> {
    const res = await this.client<ApiResponse<RegraRematricula>>(this.path, { method: 'POST', body: cmd });
    assertApiSuccess(res); return res.data;
  }
  async update(id: string, cmd: UpsertRegraRematriculaCommand): Promise<RegraRematricula> {
    const res = await this.client<ApiResponse<RegraRematricula>>(`${this.path}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res); return res.data;
  }
}
